import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

import { GetLocationListType, getLocationsForFilter, getUsers, GetUsersType } from '../models/_location';
import { fetchDataFromAPI } from './fetchDataFromAPI';
import { GetBoardListType, getBoardsList } from '../models/_board';
import { getBlendersList, GetBlendersListType } from '../models/_blenders';
import { getTubeShieldList, GetTubeShieldListType } from '../models/_tubeShield';
import { GetCupHolderListType, getCupHoldersList } from '../models/_cupHolders';
import { getHardwareVersionsList, getMachinesNameAndSerials, GetMachinesNameAndSerialsMachineType, getMachineStatusList, GetMachineStatusListType } from '../models/_machine';
import { GetRegionListType, getRegionsList } from '../models/_region';
import { getMarketSegmentList, GetMarketSegmentListType } from '../models/_marketSegment';
import {  GetLocationTypeListType, getLocationTypesList } from '../models/_locationType';
import { getCustomerList, GetCustomerListType } from '../models/_customer';
import { getLedRingList, GetLedRingsListType } from '../models/_ledRings';


interface MachineContextProps {
    locationsDB: GetLocationListType[];
    blendersDB: GetBlendersListType[];
    tubeShieldsDB: GetTubeShieldListType[];
    managersDB: GetUsersType[];
    boardsDB: GetBoardListType[];
    cupHolderDB:GetCupHolderListType[];
    machineStatusDB: GetMachineStatusListType[];
    machineDB: GetMachinesNameAndSerialsMachineType[];
    regionDB:GetRegionListType[];
    userDB: GetUsersType[];
    marketSegmentDB: GetMarketSegmentListType[];
    locationTypeDB:GetLocationTypeListType[];
    hardwareVersionDB:any[];
    customerDB:GetCustomerListType[];
    ledRingsDB: GetLedRingsListType[];
    loading: boolean;
    
}

 export const MachineContext = createContext<MachineContextProps>({ 
    blendersDB: [],
    locationsDB: [],
    tubeShieldsDB: [],
    managersDB:[],
    boardsDB: [],
    cupHolderDB:[],
    machineStatusDB:[],
    machineDB:[],
    regionDB:[],
    userDB:[],
    marketSegmentDB: [],
    locationTypeDB:[],
    hardwareVersionDB:[],
    customerDB:[],
    ledRingsDB:[],
    loading: false,
});

interface MachineProviderProps {
    children: ReactNode;
}

export const MachineDataProvider: React.FC<MachineProviderProps> = ({ children }) => {
   
      const [locationsDB, setLocationsDB] = useState<GetLocationListType[]>([]);
         const [blendersDB, setBlendersDB] = useState<GetBlendersListType[]>([]);
         const [tubeShieldsDB, setTubeShieldsDB] = useState<GetTubeShieldListType[]>([]);
         const [managersDB, setManagersDB] = useState<GetUsersType[]>([]);
          const [boardsDB, setBoardsDB] = useState<GetBoardListType[]>([]);
          const [cupHolderDB, setCupHolderDB] = useState<GetCupHolderListType[]>([]);
         const [machineStatusDB, setMachineStatusDB] = useState<GetMachineStatusListType[]>([]);
         const [machineDB, setMachineDB] = useState<GetMachinesNameAndSerialsMachineType[]>([]);
         const [regionDB, setRegionDB] = useState<GetRegionListType[]>([]);
         const [userDB, setUserDB] = useState<GetUsersType[]>([]);
         const [marketSegmentDB, setMarketSegmentDB] = useState<GetMarketSegmentListType[]>([]);
         const [locationTypeDB, setLocationTypeDB] = useState<GetLocationTypeListType[]>([]);
         const [hardwareVersionDB, setHardwareVersionDB] = useState([]);
         const [customerDB, setCustomerDB] = useState<GetCustomerListType[]>([]);
         const [ledRingsDB, setLedRingsDB] = useState<GetLedRingsListType[]>([]);
         const [loading, setLoading] = useState(false);

 const fetchData = async () => {
        try {
            setLoading(true);

            const [
                blendersResult,
                tubeShieldsResult,
                locationsResult,
                managerResult,
                boardsResult,
                cupHolderResult,
                machineStatusResult,
                machineResult,
                regionResult,
                userResult,
                marketSegmentResult,
                locationTypeResult,
                hardwareVersionResult,
                customerResult,
                ledRingsResult
            ] = await Promise.all([
                fetchDataFromAPI(getBlendersList),
                fetchDataFromAPI(getTubeShieldList),
                fetchDataFromAPI(getLocationsForFilter),
                fetchDataFromAPI(getUsers),
                fetchDataFromAPI(getBoardsList),
                fetchDataFromAPI(getCupHoldersList),
                fetchDataFromAPI(getMachineStatusList),
                fetchDataFromAPI(getMachinesNameAndSerials),
                fetchDataFromAPI(getRegionsList),
                fetchDataFromAPI(getUsers),
                fetchDataFromAPI(getMarketSegmentList),
                fetchDataFromAPI(getLocationTypesList),
                fetchDataFromAPI(getHardwareVersionsList),
                fetchDataFromAPI(getCustomerList),
                fetchDataFromAPI(getLedRingList),


            ]);

            const blendersDBResult = blendersResult.sort((a: any, b: any) =>
                a.title.toLowerCase().localeCompare(b.title.toLowerCase())
            );

            const boardsDBResult = boardsResult.sort((a: any, b: any) =>
                a.title.toLowerCase().localeCompare(b.title.toLowerCase())
            );

            const locationIdResults: any = locationsResult?.data || [];
            const locationsResultSorted = locationIdResults.sort((a: any, b: any) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            );

            const deploymentManagerResults = managerResult.sort((a: any, b: any) =>
                a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
            );

            const cupHolderResults = cupHolderResult.sort((a: any, b: any) =>
                a.title.toLowerCase().localeCompare(b.title.toLowerCase())
            );

            const machineResults: any = machineResult?.data || [];
            const machineResultsSorted = machineResults.sort((a: any, b: any) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            );

            setBlendersDB(blendersDBResult);
            setTubeShieldsDB(tubeShieldsResult);
            setLocationsDB(locationsResultSorted);
            setManagersDB(deploymentManagerResults);
            setBoardsDB(boardsDBResult);
            setCupHolderDB(cupHolderResults);
            setMachineStatusDB(machineStatusResult);
            setMachineDB(machineResultsSorted);
            setRegionDB(regionResult);
            setUserDB(userResult);
            setMarketSegmentDB(marketSegmentResult);
            setLocationTypeDB(locationTypeResult);
            setHardwareVersionDB(hardwareVersionResult);
            setCustomerDB(customerResult)
            setLedRingsDB(ledRingsResult);

            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return (
      
        <MachineContext.Provider value={{ledRingsDB, customerDB,hardwareVersionDB,locationTypeDB,marketSegmentDB,userDB, regionDB, loading, blendersDB,tubeShieldsDB,locationsDB,managersDB,boardsDB,cupHolderDB ,machineStatusDB, machineDB}}>
            {children}
        </MachineContext.Provider>
    );
};
export const useMachine = () => useContext(MachineContext);
